<template>
  <v-container fluid>
    <v-btn
      fab
      fixed
      right
      bottom
      color="success"
      v-if="!btnTools"
      @click="btnTools = !btnTools"
      class="mb-14"
    >
      <v-icon>fa-filter</v-icon>
    </v-btn>
    <v-dialog v-model="btnTools" max-width="400">
      <v-card class="pa-5">
        <v-card-title> Инструменты анализа </v-card-title>
        <v-card-actions>
          <v-checkbox label="Карта" v-model="isMapCheckbox"> </v-checkbox>
        </v-card-actions>
        <v-card-actions>
          <v-checkbox label="График" v-model="isGraphCheckbox"> </v-checkbox>
        </v-card-actions>
        <v-card-actions>
          <v-checkbox label="График" v-model="isTimeGraphCheckbox">
          </v-checkbox>
        </v-card-actions>
        <v-card-actions>
          <v-checkbox label="3d График" v-model="is3dGraphCheckbox">
          </v-checkbox>
        </v-card-actions>
        <v-card-actions>
          <v-btn color="primary" @click="showTools">Применить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="isMap">
      <FilterDtp />
      <v-row justify="center">
        <v-col cols="12" md="8" lg="8"><Osmap /></v-col>
        <v-col cols="12" md="3" lg="3"><Info /></v-col>
      </v-row>
    </div>

    <v-row justify="center">
      <v-col cols="12" lg="8" md="10">
        <div v-if="isDtpGraph">
          <Plotly
            :data="TYPE_DTP_COUNT.data"
            :layout="TYPE_DTP_COUNT.layout"
            :display-mode-bar="true"
          >
          </Plotly>
          <v-row justify="center">
            <v-col cols="12" md="3" lg="3">
              <v-select
                v-model="year"
                :items="years_items"
                label="Год"
                multiple
                dense
              ></v-select>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-select
                v-model="dtp_type"
                :items="dtp_type_items"
                label="Тип данных"
                dense
              ></v-select>
            </v-col>

            <v-col cols="12" md="3" lg="3"
              ><v-btn color="primary" @click="filteredGraph('type_dtp_count')"
                >Применить</v-btn
              ></v-col
            >
          </v-row>
        </div>
      </v-col>

      <v-col cols="12" lg="8" md="10">
        <div v-if="isDtpTimeGraph">
          <Plotly
            :data="HIST_DTP_IN_TIME.data"
            :layout="HIST_DTP_IN_TIME.layout"
            :display-mode-bar="true"
          >
          </Plotly>
           <v-row justify="center">
            <v-col cols="12" md="3" lg="3">
              <v-select
                v-model="year1"
                :items="years_items"
                label="Год"
                multiple
                dense
              ></v-select>
            </v-col>

            <v-col cols="12" md="3" lg="3"
              ><v-btn color="primary" @click="filteredGraph('hist_dtp_in_time')"
                >Применить</v-btn
              ></v-col
            >
          </v-row>
        </div>
      </v-col>

      <v-col cols="12" lg="8" md="10">
        <div v-if="is3dGraph">
          <Plotly
            :data="PLOT_3D_TEST.data"
            :layout="PLOT_3D_TEST.layout"
            :display-mode-bar="true"
          >
          </Plotly>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FilterDtp from "@/components/FilterDtp.vue";
import { Plotly } from "vue-plotly";
import Osmap from "../components/osmap.vue";
import Info from "../components/Info.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    FilterDtp,
    Plotly,
    Osmap,
    Info,
  },
  data() {
    return {
      years_items: [],
      year: [],
      year1: [],
      sortByAscending: "",
      isMap: false,
      isDtpTimeGraph: false,
      isDtpGraph: false,
      is3dGraph: false,
      isMapCheckbox: false,
      isGraphCheckbox: false,
      isTimeGraphCheckbox: false,
      is3dGraphCheckbox: false,
      btnTools: true,
      dtp_type_items: [
        { value: "type_dtp", text: "Тип ДТП" },
        { value: "loss", text: "Погибло" },
        { value: "loss_child", text: "Погибло детей" },
        { value: "injured", text: "Ранено" },
        { value: "injured_child", text: "Ранено детей" },
        { value: "road_condition", text: "Состояние проезжей части" },
        { value: "weather_1", text: "Состояние погоды 1" },
        { value: "weather_2", text: "Состояние погоды 2" },
        { value: "lighting", text: "Освещение" },
        { value: "dividing_line_type", text: "Вид разделительной полосы" },
        { value: "location", text: "Расположение" },
      ],
      dtp_type: "",
    };
  },
  methods: {
    ...mapActions([
      "GET_TYPE_DTP_COUNT",
      "GET_HIST_DTP_IN_TIME",
      "GET_PLOT_3D_TEST",
      "GET_FILTERED_GRAPH",
    ]),
    showTools() {
      this.isMap = this.isMapCheckbox;
      this.isDtpGraph = this.isGraphCheckbox;
      (this.isDtpTimeGraph = this.isTimeGraphCheckbox),
        (this.is3dGraph = this.is3dGraphCheckbox),
        (this.btnTools = !this.btnTools);
    },
    filteredGraph(url) {
      let options = { year: this.year, dtp_type: this.dtp_type, url: url};
      this.GET_FILTERED_GRAPH(options);
    },
  },
  computed: {
    ...mapGetters(["TYPE_DTP_COUNT", "HIST_DTP_IN_TIME", "PLOT_3D_TEST"]),
  },
  mounted() {
    this.GET_TYPE_DTP_COUNT();
    this.GET_HIST_DTP_IN_TIME();
    this.GET_PLOT_3D_TEST();
    let data = new Date();
    for (let i = data.getFullYear(); i >= 2016; i--) {
      this.years_items.push(i);
    }
  },
};
</script>
